import React, { useEffect, useState } from 'react';
import axios from 'axios';
import tt from '@tomtom-international/web-sdk-maps';
import '@tomtom-international/web-sdk-maps/dist/maps.css'; // Import the CSS

const MapComponent = () => {
    const [map, setMap] = useState(null);

    useEffect(() => {
        const newMap = tt.map({
            key: '3YzQxwAFHF8yAMWxHfKrjbNN1U3WHarx', // Replace with your actual TomTom API key
            container: 'map',
            center: [0, 0],
            zoom: 14
        });

        newMap.addControl(new tt.NavigationControl());
        setMap(newMap);

        // Cleanup function to remove map on component unmount
        return () => newMap.remove();
    }, []);

    useEffect(() => {
        if (!map) return; // Wait for the map to initialize

        const createMarker = (lngLat, color, popupText, onClick) => {
            const marker = new tt.Marker({ color })
                .setLngLat(lngLat)
                .setPopup(new tt.Popup().setText(popupText))
                .addTo(map);

            if (onClick) {
                marker.getElement().addEventListener('click', () => {
                    onClick(lngLat);
                });
            }
        };

        const getUserLocation = (callback) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(callback, (error) => {
                    console.error("Error getting user location: ", error);
                });
            } else {
                console.error("Geolocation is not supported by this browser.");
            }
        };

        getUserLocation((position) => {
            const userLocation = [position.coords.longitude, position.coords.latitude];
            map.setCenter(userLocation);

            // Add marker for user's location
            createMarker(userLocation, 'blue', 'You are here');

            // Fetch and display nearby locations
            fetchNearbyLocations(userLocation);
        });

        const fetchNearbyLocations = (userLocation) => {
            const searchUrl = `https://api.tomtom.com/search/2/nearbySearch.json?key=3YzQxwAFHF8yAMWxHfKrjbNN1U3WHarx&lat=${userLocation[1]}&lon=${userLocation[0]}&radius=5000&query=gym,yoga&categorySet=7320`;

            axios.get(searchUrl)
                .then((response) => {
                    const locations = response.data.results;
                    if (!locations || locations.length === 0) {
                        console.error("No locations found.");
                        return;
                    }

                    const bounds = new tt.LngLatBounds(); // Initialize bounds
                    // Add user's location to bounds
                    bounds.extend(userLocation);
                    createMarker(userLocation, 'blue', 'You are here');

                    locations.forEach((location) => {
                        const position = [location.position.lon, location.position.lat];
                        createMarker(position, 'red', location.poi.name, (targetLocation) => {
                            drawRoute(userLocation, targetLocation);
                        });
                        bounds.extend(position); // Add each location to bounds
                    });

                    // Fit the map bounds to include all markers
                    map.fitBounds(bounds, { padding: 50 });
                })
                .catch((error) => {
                    console.error("Error fetching nearby locations: ", error);
                });
        };

        const drawRoute = (start, end) => {
            const routeUrl = `https://api.tomtom.com/routing/1/calculateRoute/${start[1]},${start[0]}:${end[1]},${end[0]}/json?key=3YzQxwAFHF8yAMWxHfKrjbNN1U3WHarx&travelMode=car&traffic=true`;

            axios.get(routeUrl)
                .then((response) => {
                    const routeData = response.data.routes[0];
                    if (!routeData || !routeData.legs) {
                        console.error("No route found.");
                        return;
                    }
                    const geoJson = {
                        type: 'FeatureCollection',
                        features: [{
                            type: 'Feature',
                            geometry: {
                                type: 'LineString',
                                coordinates: routeData.legs[0].points.map(point => [point.longitude, point.latitude])
                            }
                        }]
                    };

                    // Remove existing route layers if any
                    if (map.getLayer('route')) {
                        map.removeLayer('route');
                        map.removeSource('route');
                    }

                    // Add the route to the map
                    map.addLayer({
                        id: 'route',
                        type: 'line',
                        source: {
                            type: 'geojson',
                            data: geoJson
                        },
                        paint: {
                            'line-color': '#000000', // Red color for the route
                            'line-width': 6 // Thicker line width
                        }
                    });

                    // Update bounds to include route
                    const routeBounds = new tt.LngLatBounds();
                    geoJson.features[0].geometry.coordinates.forEach(coord => routeBounds.extend(coord));
                    map.fitBounds(routeBounds, { padding: 50 });
                })
                .catch((error) => {
                    console.error("Error drawing route: ", error);
                });
        };
    }, [map]); // This effect depends on the map object

    return <>
        <div style={{ textAlign: 'center' , paddingBottom: '30px'}}>
            <h1>Gyms Near You</h1>
            <div id="map" style={{ width: '70vw', height: '70vh', margin: 'auto', display: 'block' }}></div>
        </div>
    </>
};

export default MapComponent;
